var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Collection from "../Collection";
import SampleModel from "../../models/SampleModel";
/**
 *
 */
var SampleCollection = /** @class */ (function (_super) {
    __extends(SampleCollection, _super);
    /**
     *
     */
    function SampleCollection() {
        return _super.call(this, SampleModel) || this;
    }
    SampleCollection.prototype.getSamplesForAsset = function (assetMetricsId) {
        return this.list.filter(function (sampleModel) { return sampleModel.assetMetricsId === assetMetricsId; });
    };
    SampleCollection.prototype.getSamplesForAssetAndMeasurement = function (assetMetricsId, measurementId) {
        return [].concat(this.list).filter(function (sampleModel) {
            return sampleModel.assetMetricsId === assetMetricsId && sampleModel.measurementId === measurementId;
        });
    };
    return SampleCollection;
}(Collection));
export default SampleCollection;
